<template>
  <b-form>
    <b-button v-if="item.clientName" block variant="danger" class="mb-1" @click.stop.prevent="showAll">Показать всех
      клиентов
    </b-button>
    <b-card border-variant="primary" header-border-variant="primary"
            header-bg-variant="light"
            header-text-variant="dark" header-class="text-center">
      <h5 v-if="item.clientName" slot="header">
        {{ item.clientName }}
      </h5>
      <b-card-text>
        <b-card no-body class="mb-2">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block href="#" v-b-toggle.accordion-2 variant="outline-primary">
              Базовая функциональная диагностика
            </b-button>
          </b-card-header>
          <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <b-card-text class="alert alert-success">Это интегральная величина, объединяющая физический,
                Предназначена для определения спортивного возраста, потенциальных пульсовых
                возможностей, уровней функционирования систем энергообеспечения и степени восстановления
                после физических нагрузок. Выполняется обычно вечером перед сном, когда регистрируются
                показатели артериального давления, пульса и дыхания. Рост и вес регистрируется в этот же
                день утром, а число отжиманий от пола (или подъёмов туловища) и время стояния в планке
                на локтях являются известными среднестатистическими результатами текущего месяца.
                Регулярность этого тестирования - по количеству тренировок в неделю.
              </b-card-text>
            </b-card-body>
          </b-collapse>
        </b-card>
        <b-alert show variant="warning">
          <b-row>
            <b-col>
              <b-form-group
                  id="fieldset-height"
                  label="Рост"
                  description="от 140 до 220 см"
                  label-for="input-height">
                <b-input-group>
                  <b-form-input id="input-height" type="text" v-model="data.height"
                                trim></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                  id="fieldset-weight"
                  label="Вес"
                  description="от 40 до 130 кг"
                  label-for="input-weight">
                <b-input-group>
                  <b-form-input id="input-weight" type="text" v-model="data.weight"
                                trim></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                  id="fieldset-age"
                  label="Возраст"
                  description="от 12 до 100 лет"
                  label-for="input-age">
                <b-input-group>
                  <b-form-input id="input-age" type="text" v-model="data.age" trim></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
        </b-alert>
        <b-alert show variant="primary">
          <b-row>
            <b-col>
              <b-form-group
                  id="fieldset-bpsys"
                  label="Систолическое артериальное давление"
                  description="от 50 до 220 мм рт.ст."
                  label-for="input-bpsys">
                <b-input-group>
                  <b-form-input id="input-bpsys" type="text" v-model="data.bpsys" trim></b-form-input>
                  <b-button id="popover-input-bpsys" variant="outline-info">i</b-button>
                  <b-popover target="popover-input-bpsys" placement="top" title="Как измерить?"
                             triggers="hover"
                             content="В покое, с помощью аппарата для измерения артериального давления на левом плече."></b-popover>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                  id="fieldset-bpdia"
                  label="Диастолическое артериальное давление"
                  description="от 10 до 130 мм рт.ст."
                  label-for="input-bpdia">
                <b-input-group>
                  <b-form-input id="input-bpdia" type="text" v-model="data.bpdia" trim></b-form-input>
                  <b-button id="popover-input-bpdia" variant="outline-info">i</b-button>
                  <b-popover target="popover-input-bpdia" placement="top" title="Как измерить?"
                             triggers="hover"
                             content="В покое, с помощью аппарата для измерения артериального давления на левом плече."></b-popover>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
        </b-alert>
        <b-alert show variant="info">
          <b-row>
            <b-col>
              <b-form-group
                  id="fieldset-hr"
                  label="Пульс"
                  description="от 40 до 140 уд/мин"
                  label-for="input-hr">
                <b-input-group>
                  <b-form-input id="input-hr" type="text" v-model="data.hr" trim></b-form-input>
                  <b-button id="popover-input-hr" variant="outline-info">i</b-button>
                  <b-popover target="popover-input-hr" placement="top" title="Как измерить?"
                             triggers="hover"
                             content="В покое, вручную за 1 минуту, либо с помощью пульсометра."></b-popover>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                  id="fieldset-rr"
                  label="Дыхание или ПСВ"
                  description="от 4 до 28 вдох/мин или от 100 до 900 л/мин"
                  label-for="input-rr">
                <b-input-group>
                  <b-form-input id="input-rr" type="text" v-model="data.rr" trim></b-form-input>
                  <b-button id="popover-input-rr" variant="outline-info">i</b-button>
                  <b-popover target="popover-input-rr" placement="top" title="Как измерить?"
                             triggers="hover"
                             content="В покое подсчитывается количество вдохов за 1 минуту или пикфлоуметром пиковая скорость выдоха"></b-popover>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
        </b-alert>
        <b-alert show variant="danger">
          <b-row>
            <b-col>
              <b-form-group
                  id="fieldset-ib"
                  label="Подъёмы туловища + Отжимания от пола"
                  description="от 0 до 120 раз"
                  label-for="input-ib">
                <b-input-group>
                  <b-form-input id="input-ib" type="text" v-model="data.ib" trim></b-form-input>
                  <b-button id="popover-input-ib" variant="outline-info">i</b-button>
                  <b-popover target="popover-input-ib" placement="top"
                             title="Как измерить?"
                             triggers="hover"
                             content="Подъёмы туловища за 1 минуту + отжимания от пола за 1 минуту"></b-popover>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                  id="fieldset-fbes"
                  label="Локтевая планка"
                  description="от 0 до 120 сек"
                  label-for="input-fbes">
                <b-input-group>
                  <b-form-input id="input-fbes" type="text" v-model="data.fbes" trim></b-form-input>
                  <b-button id="popover-input-fbes" variant="outline-info">i</b-button>
                  <b-popover target="popover-input-fbes" placement="top" title="Как измерить?"
                             triggers="hover"
                             content="Планка из стойки на локтях. Приняв положение лежа (животом вниз), встать на локти. Затем приподнять тело таким образом, чтобы мысленно образовалась прямая линия. Важно не допускать провисания или подъёма тазовой области туловища. Такое положение следует удерживать максимальное количество времени (секунды)."></b-popover>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
        </b-alert>
        <b-button :disabled="!calculateEnable" block variant="danger" @click.stop.prevent="calculateBase">
          Рассчитать
          <template v-if="remainCount !== -1">
            <b-badge v-if="remainCount === 0" variant="light">{{ remainCount }}</b-badge>
            <b-badge v-else-if="calculateEnable" variant="light">{{ remainCount }}</b-badge>
            <b-spinner v-else small type="grow"/>
          </template>
        </b-button>
      </b-card-text>
    </b-card>
    <b-card class="mt-3" v-if="diagnosisTable.out" border-variant="primary" header-border-variant="primary"
            header-bg-variant="light"
            header-text-variant="dark" header-class="text-center">
      <b-form-row v-if="data.out.realBiologicalAge">
        <b-col lg="6" class="mb-2">
          <RealBiologicalAge :data="diagnosisTable"/>
        </b-col>
        <b-col lg="6" class="mb-2">
          <SportAge :data="diagnosisTable"/>
        </b-col>
      </b-form-row>
      <template v-else>
        <SportAge :data="diagnosisTable"/>
      </template>

      <b-form-row>
        <b-col lg="4" class="mb-2">
          <SOPFactor title="Креатинфосфатная ёмкость" :coeff="data.out.sopMuscleLevel"/>
        </b-col>
        <b-col lg="4" class="mb-2">
          <RiskFactors title="Анаэробная мощность" :coeff="data.out.ksdMuscleLevel"/>
        </b-col>
        <b-col lg="4" class="mb-2">
          <RiskFactors title="Аэробная мощность" :coeff="data.out.kyadMuscleLevel"/>
        </b-col>
      </b-form-row>
      <ODV class="mb-2 mt-2" :data="diagnosisTable"/>
      <b-card no-body class="mb-2">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button block href="#" v-b-toggle.accordion-3 variant="outline-primary">
            Заключение по базовой функциональной диагностике
          </b-button>
        </b-card-header>
        <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <b-card-text class="alert alert-secondary text-justify">
              Результатом базовой функциональной диагностики являются общие рекомендации по типу
              тренировочной
              работы в зависимости от спортивного возраста, пульсовых возможностей и степени
              восстановления, а
              также расчёт вариантов персональных схем тренировок на выносливость в зависимости от
              состояния
              систем энергообеспечения.
              <ul class="list-group">
                <li class="list-group-item list-group-item-success">
                  1) Схема тренировки “ИНТЕНСИВНАЯ”: мощность максимальная (85-95%); тренировочная
                  зона
                  анаэробная (лактатная); пульс ~165-180 bpm и более.
                </li>
                <li class="list-group-item list-group-item-success">
                  2) Схема тренировки “ТЕМПОВАЯ”: мощность субмаксимальная (75-85%); тренировочная
                  зона
                  смешанная; пульс ~155-170 bpm.
                </li>
                <li class="list-group-item list-group-item-warning">
                  3) Схема тренировки “ЭКСТЕНСИВНАЯ”: мощность средняя (65-75%); тренировочная зона
                  аэробная
                  (кислородная); пульс ~145-160 bpm.
                </li>
                <li class="list-group-item list-group-item-primary">
                  4) Схема тренировки “ВОССТАНОВИТЕЛЬНАЯ”: мощность малая (55-65%); тренировочная зона
                  аэробная
                  (кислородная); пульс ~135-150 bpm.
                </li>
                <li class="list-group-item list-group-item-danger">
                  5) Схема тренировки “ЛФК”: мощность крайне малая (45-55%); тренировочная зона
                  аэробная
                  (кислородная); пульс ~125-140 bpm и менее.
                </li>
              </ul>
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>
      <template v-if="sportTestVisible">
        <SOPConclusion :data="diagnosisTable"/>
        <BaseTestConclusion :data="diagnosisTable"/>
      </template>
      <b-alert v-else show variant="danger" class="text-center">
        <h5 class="alert-heading">Рекомендовано обратиться за медицинской консультацией по
          состоянию здоровья</h5>
      </b-alert>
      <b-button v-if="item.clientName" block variant="danger" :disabled="!recalculated" @click.stop.prevent="addToChart"
                class="mt-2">
        Добавить в базу
      </b-button>
    </b-card>
    <b-card class="mt-3" v-if="sportTestVisible" border-variant="primary" header-border-variant="primary"
            header-bg-variant="light"
            header-text-variant="dark" header-class="text-center">
      <b-card no-body class="mb-2">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button block href="#" v-b-toggle.accordion-4 variant="outline-primary">
            Спортивная функциональная диагностика
          </b-button>
        </b-card-header>
        <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <b-card-text class="alert alert-light text-justify">
              <div class="alert alert-success text-justify">
                Представляет собой нагрузочный тест максимальной мощности (типа теста Купера),
                предназначенный для
                определения индивидуального лактатного (анаэробного) порога с целью построения
                персональной
                программы тренировок на выносливость. Выполняется обычно в первой половине дня после
                предварительной
                разминки. Регулярность этого тестирования - 1 раз в 2-3 месяца.
              </div>
              <hr/>
              <div class="alert alert-secondary text-justify">
                В зависимости от условий выполняется один из вариантов теста Купера.
                Первый тест Купера состоит из 12-минутного бега, либо плавания, либо езды на велосипеде
                с
                последующим анализом спортивных и медицинских показателей. Достоинством этого теста
                является то, что
                его результат варьирует в зависимости от календарного возраста.
                Второй тест Купера может выполняться в небольших помещениях. Этот тест не зависит от
                возраста.
                Испытуемому предстоит выполнить четыре тестовых круга, каждый из которых состоит из
                четырёх
                последовательных серий упражнений по 10 повторений:
                1 серия - исходное положение упор лёжа, выполняется 10 отжиманий;
                2 серия - исходное положение упор лёжа, выполняется 10 прыжков;
                3 серия - исходное положение на спине, выполняется 10 подъёмов (сгибаний) туловища или
                10 отведений
                ног за голову;
                4 серия - исходное положение стоя, выполняется 10 приседаний или 10 прыжков-разножек.
                Оценка второго теста Купера: 3 минуты и менее – «отлично»; 3 минуты 30 секунд –
                «хорошо»; 4 минуты
                30 секунд – «удовлетворительно»; более 4 минут 30 секунд – «неудовлетворительно».
              </div>
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>
      <b-alert show variant="danger">
        <b-row>
          <b-col>
            <b-form-group
                id="fieldset-hrStart"
                label="Пульс на старте"
                description="от 60 до 159 уд/мин"
                label-for="input-hrStart">
              <b-input-group>
                <b-form-input id="input-hrStart" type="text" v-model="data.hrStart" trim></b-form-input>
                <b-button id="popover-input-hrStart" variant="outline-info">i</b-button>
                <b-popover target="popover-input-hrStart" placement="top"
                           title="Как измерить?"
                           triggers="hover"
                           content="Пульс в начале нагрузочного теста максимальной мощности."></b-popover>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
                id="fieldset-hrEnd"
                label="Пульс на финише"
                description="от 110 до 199 уд/мин"
                label-for="input-hrEnd">
              <b-input-group>
                <b-form-input id="input-hrEnd" type="text" v-model="data.hrEnd" trim></b-form-input>
                <b-button id="popover-input-hrEnd" variant="outline-info">i</b-button>
                <b-popover target="popover-input-hrEnd" placement="top"
                           title="Как измерить?"
                           triggers="hover"
                           content="Пульс в конце нагрузочного теста максимальной мощности."></b-popover>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
      </b-alert>
      <b-button :disabled="!calculateEnable" block variant="danger" @click.stop.prevent="calculateSport">
        Рассчитать нагрузочные показатели
        <template v-if="remainCount !== -1">
          <b-badge v-if="remainCount === 0" variant="light">{{ remainCount }}</b-badge>
          <b-badge v-else-if="calculateEnable" variant="light">{{ remainCount }}</b-badge>
          <b-spinner v-else small type="grow"/>
        </template>
      </b-button>
    </b-card>
    <b-card class="mt-3" v-if="diagnosisTable.out2iap" border-variant="primary" header-border-variant="primary"
            header-bg-variant="light"
            header-text-variant="dark" header-class="text-center">
      <b-form-row>
        <b-col lg="6" class="mb-2">
          <MNT :coeff="data.out2iap.mnt"/>
        </b-col>
        <b-col lg="6" class="mb-2">
          <IAP :coeff="data.out2iap.iap"/>
        </b-col>
      </b-form-row>
    </b-card>
    <b-card class="mt-3" v-if="diagnosisTable.out2iap" border-variant="primary" header-border-variant="primary"
            header-bg-variant="light"
            header-text-variant="dark" header-class="text-center">
      <b-alert show variant="warning">
        <b-row>
          <b-col>
            <b-form-group
                id="fieldset-stScore"
                label="Оценка за нагрузочный тест"
                description="от 1 до 5 баллов"
                label-for="input-stScore">
              <b-input-group>
                <b-form-input id="input-stScore" type="text" v-model="data.stScore" trim></b-form-input>
                <b-button id="popover-input-stScore" variant="outline-info">i</b-button>
                <b-popover target="popover-input-stScore" placement="top"
                           title="Как измерить?"
                           triggers="hover"
                           content="Оценка за нагрузочный тест выставляется в соответствии с возрастными нормативами."></b-popover>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
                id="fieldset-hrMin2"
                label="Пульс восстановления через 2 минуты"
                description="от 100 до 160 уд/мин"
                label-for="input-hrMin2">
              <b-input-group>
                <b-form-input id="input-hrMin2" type="text" v-model="data.hrMin2" trim></b-form-input>
                <b-button id="popover-input-hrMin2" variant="outline-info">i</b-button>
                <b-popover target="popover-input-hrMin2" placement="top"
                           title="Как измерить?"
                           triggers="hover"
                           content="Пульс через 2 минуты после финиша."></b-popover>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
      </b-alert>
      <b-button :disabled="!calculateEnable" block variant="danger" @click.stop.prevent="calculateSFP">
        Рассчитать
        <template v-if="remainCount !== -1">
          <b-badge v-if="remainCount === 0" variant="light">{{ remainCount }}</b-badge>
          <b-badge v-else-if="calculateEnable" variant="light">{{ remainCount }}</b-badge>
          <b-spinner v-else small type="grow"/>
        </template>
      </b-button>
    </b-card>
    <b-card class="mt-3" v-if="diagnosisTable.out3sfp" border-variant="primary" header-border-variant="primary"
            header-bg-variant="light"
            header-text-variant="dark" header-class="text-center">
      <SFP :coeff="data.out3sfp.sfp"/>
      <BasalMetabolicRate v-if="data.out3sfp.bmr" :data="diagnosisTable"/>
      <TrainingConclusion :data="diagnosisTable"/>
      <b-button v-if="item.clientName" block variant="danger" :disabled="!recalculated" @click.stop.prevent="addToChart"
                class="mt-2">
        Добавить в базу
      </b-button>
    </b-card>
  </b-form>
</template>

<script>
import axios from 'axios';
import _ from 'lodash';
import SportAge from "./outputs/SportAge.vue";
import RealBiologicalAge from "./outputs/RealBiologicalAge.vue";
import ODV from "./outputs/ODV.vue";
import RiskFactors from "./outputs/RiskFactors";
import SOPFactor from "./outputs/SOPFactor";
import SOPConclusion from "./outputs/SOPConclusion";
import BaseTestConclusion from "./outputs/BaseTestConclusion";
import MNT from "./outputs/MNT";
import IAP from "./outputs/IAP";
import SFP from "./outputs/SFP";
import TrainingConclusion from "./outputs/TrainingConclusion";
import BasalMetabolicRate from "./outputs/BasalMetabolicRate";

export default {
  components: {
    BasalMetabolicRate,
    SFP,
    SportAge,
    RealBiologicalAge,
    ODV,
    RiskFactors,
    SOPFactor,
    SOPConclusion,
    BaseTestConclusion,
    MNT,
    IAP,
    TrainingConclusion,
  },
  props: {
    authorizationToken: {
      type: String,
      default: '',
    },
    item: {
      type: Object,
    },
  },
  created: function () {
    axios.defaults.baseURL = 'https://l01s75qla5.execute-api.us-east-1.amazonaws.com/prod';
    axios.defaults.headers.common['Authorization'] = this.authorizationToken;
    if (this.item.clientName) {
      this.readOnce();
    }
    this.readRemainCount();
  },
  computed: {
    sportTestVisible: function () {
      if (this.diagnosisTable.out) {
        let sop = this.diagnosisTable.out.sop;
        let ksd = this.diagnosisTable.out.ksd;
        let kyad = this.diagnosisTable.out.kyad;
        let odv = this.diagnosisTable.out.odv;
        return _.inRange(sop, 0.5, 2.05) && _.inRange(ksd, 0.5, 2.05) && _.inRange(kyad, 0.5, 2.05) && odv < 72;
      }
      else {
        return false;
      }
    },
  },
  data() {
    return {
      data: {
        site: this.item.site,
        clientLogin: this.item.id,
        clientName: this.item.clientName,
        height: 178,
        weight: 74,
        age: 35,
        bpsys: 120,
        bpdia: 75,
        hr: 68,
        rr: 16,
        ib: 25,
        fbes: 20,

        hrStart: 60,
        hrEnd: 110,

        stScore: 1,
        hrMin2: 120,
      },
      diagnosisTable: {},
      calculateEnable: false,
      recalculated: false,
      remainCount: -1,
    }
  },
  methods: {
    showAll() {
      this.$emit('showAll');
    },
    mergeData(data) {
      if (!(this.data.hrStart && this.data.hrEnd)) {
        this.data.hrStart = 60;
        this.data.hrEnd = 110;
      }
      if (!(this.data.stScore && this.data.hrMin2)) {
        this.data.stScore = 1;
        this.data.hrMin2 = 120;
      }
      this.data = Object.assign({}, this.data, data);
      this.diagnosisTable = Object.assign({}, this.diagnosisTable, data);
    },
    readOnce() {
      let data = this.data;
      this.data = {};
      let vm = this;
      axios.post('/cyberanalysis', {
        site: this.item.site,
        clientLogin: this.item.id,
      }).then(function (response) {
        vm.data = data;
        if (response.data.length > 0) {
          vm.mergeData(response.data[0]);
        }
        vm.data.site = vm.item.site;
      }).catch(function () {
        vm.data = data;
      });
    },
    readRemainCount() {
      let vm = this;
      this.calculateEnable = false;
      axios.post('/remains', {}).then(function (response) {
        vm.remainCount = response.data.remainCount;
        vm.calculateEnable = (vm.remainCount > 0 || vm.remainCount === -1);
      }).catch(function () {
        vm.calculateEnable = false;
      });
    },
    calculate(data) {
      let vm = this;
      this.calculateEnable = false;
      this.recalculated = false;

      axios.post('/cyber1base', data).then(function (response) {
        vm.mergeData(response.data);
        vm.remainCount = response.data.remainCount;
        vm.calculateEnable = (vm.remainCount > 0 || vm.remainCount === -1);
        vm.recalculated = true;
      }).catch(function () {
        vm.recalculated = false;
      });
    },
    calculateBase() {
      let data = Object.assign({}, this.data);
      data.hrStart = null;
      data.hrEnd = null;
      data.stScore = null;
      data.hrMin2 = null;
      this.diagnosisTable.out2iap = null;
      this.diagnosisTable.out3sfp = null;
      this.calculate(data);
    },
    calculateSport() {
      let data = Object.assign({}, this.data);
      data.stScore = null;
      data.hrMin2 = null;
      this.diagnosisTable.out3sfp = null;
      this.calculate(data);
    },
    calculateSFP() {
      this.calculate(Object.assign({}, this.data));
    },
    addToChart() {
      let vm = this;
      this.recalculated = false;
      axios.post('/cyberanalysis', {
        site: this.item.site,
        clientLogin: this.item.id,
        displayAtChart: true,
      }).then(() => {
        vm.recalculated = false;
      }).catch(() => {
        vm.recalculated = true;
      });
    }
  }
}
</script>